export class EventModel {

  public Key: string = '';
  public DateInt: number;
  public UpdatedUtc: Date;
  public Description: string;
  public Transmitters: number[];

  public ProgramId: string;
  public Group: string;
  public GroupType: string;
  public GroupName: string;
  public ContinueToReliability: boolean;
  public DispatchGroupKey: string;

  public Scheduled: boolean;
  public StartTimeUtc: Date;
  public EndTimeUtc: Date;
  public Duration: number;

  public Source: string;
  public State: string;
  public StateStr: string;
  public TriggerId: string;
  public TriggerName: string;

  public NotificationSent: boolean;
  public Selected: boolean = false;
  public UpdatedBy: string;
}
